import { ref } from 'vue';
const birdCaught = ref(false);
export const useBirdState = () => {
    const catchBird = () => {
        birdCaught.value = true;
    };
    const resetBird = () => {
        birdCaught.value = false;
    };
    const isBirdCaught = () => {
        return birdCaught.value;
    };
    return {
        birdCaught,
        catchBird,
        resetBird,
        isBirdCaught
    };
};
